export class LoginRequest {
  username: string;
  password: string;
  grant_type?: string;
  institution?: string;
}

export interface Roles {
  rolename: string;
  modules: Modules[];
}

export interface Modules {
  name: string;
  read: boolean;
  create: boolean;
  delete: boolean;
  update: boolean;
}

export interface RenewalOfferDTO {
  newLicenceId: number;
  newLicenceName: string;
  newLicenceDurationMonths: number;
  newLicencePrice: number;
  offerName?: string | null;
  discountPercent?: number | null;
  discountAmount?: number | null;
  newLicencePriceWithDiscount?: number | null;
  remainingCredit?: number | null;
  amountToPay: number;
  newLicencePriceArs?: number | null;
  discountAmountArs?: number | null;
  remainingCreditArs?: number | null;
  newLicencePriceWithDiscountArs?: number | null;
  amountToPayArs?: number | null;
  currentLicenceId?: number;
  currentLicenceName?: string;
  currentExpireDate?: string;
  newExpireDate?: string;
  exchangeRate?: number | null;
}

export interface RenewalAmountDTO {
  currentLicencePrice: number;
  newLicencePrice: number;
  remainingDays: number;
  remainingCredit: number;
  amountToPay: number;
  newExpireDate: string;
}

export interface RenewalPaymentRequestDTO {
  suscriptionId: number | string;
  licenceId: number;
  amount: number;
  paymentMethod?: string;
  operationId?: string | null;
  paymentStatus?: string | null;
  paypal?: boolean;
  cardPayment?: {
    token: string;
    paymentMethodId: string;
    issuerId: string;
    installments: number;
    payerEmail: string;
    firstName: string;
    lastName: string;
    idType: string;
    idNumber: string;
  };
}

export interface RenewalPaymentResponseDTO {
  preferenceId: string;
  paypalOrderId?: string | null;
  approveUrl?: string | null;
  suscriptionId: string;
  licenceId: number;
  externalReference: string;
  amountToPay?: number | null;
  amountToPayArs?: number | null;
  mpPaymentId?: string | null;
  paymentStatus?: string | null;
}

export interface UserDetails {
  enabled: boolean;
  id: string;
  id_account: number;
  id_person: string;
  licence?: string;
  lastLogin: string;
  lastName: string;
  name: string;
  password: string;
  retries: string;
  roles: string;
  tc?: boolean;
  username: string;
  instituteId: string;
}

export class LoginResponse {
  access_token: string;
  expires_in: number;
  jti: string;
  refresh_token: string;
  scope: string;
  someField: string;
  token_type: string;
  roleDefinitions: Roles[];
  userDetails: UserDetails;
}
export interface UserRegister

  {
    "name": string,
    "surname": string,
    "documentType": {
      "code": string,
      "description": string
    },
    institution:number,
    "numberDocument": number,
    "birthday": string,
    "email": string,
    "telephones": Array<any>,
    "gender": {
      "code": string,
      "description": string
    },
}
/**


   "telephones":[
      {
         "type":{
            "id":1,
            "description":"Celular"
         },
         "areaCode":11,
         "number":68770982
      }
   ],
   }
 */
